import {NoLoginPartnerContextDetails} from "@bounce/shared/consumer/declarations";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {partner?: string; externalId?: string};

type Data = NoLoginPartnerContextDetails;

const PARTNER_CODE_BY_URL_PARTNER: Record<string, string> = {
  varo: "bounce_varo_dp",
};

const toPartnerCode = (partner?: string): string | undefined => {
  if (!partner) return undefined;
  return PARTNER_CODE_BY_URL_PARTNER[partner.toLowerCase()] || partner;
};

export const getPartnerNoLoginContext = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>("/user/partner-no-login", {
    params: {partner: toPartnerCode(variables.partner), "external-id": variables.externalId},
  });
  return result.data;
};

export const useGetPartnerNoLoginContext = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> =>
  useBaseQuery<Data, Variables>(
    ["partner-no-login", variables.partner, variables.externalId],
    getPartnerNoLoginContext,
    variables,
    options
  );
